// Pure audit text helpers, shared by the table cells and the kore adapter.
// Kept apart from both so neither imports the other.

import type { AuditDetails } from "@pej/kore/types";

/** PascalCase wire enum → spaced phrase (`DesignTemplate` → `Design Template`). */
export function formatTargetType(type: string): string {
    return type.replace(/([a-z])([A-Z])/g, "$1 $2");
}

function fieldCount(n: number, verb: string): string {
    return `${n} field${n === 1 ? "" : "s"} ${verb}`;
}

/**
 * One-line summary for the Details cell. kore's `AuditDetails` is open
 * (`{ type: string; [key: string]: unknown }`), so each branch checks the
 * payload shape; anything unrecognised reads as "—".
 */
export function summarizeDetails(details: AuditDetails): string {
    if (details.type === "Created" && Array.isArray(details.fields)) {
        return fieldCount(details.fields.length, "set");
    }
    if (details.type === "Updated" && Array.isArray(details.changes)) {
        return fieldCount(details.changes.length, "changed");
    }
    if (details.type === "Deleted" && typeof details.reason === "string" && details.reason.length > 0) {
        return details.reason;
    }
    if (details.type === "DisplayTokenRotated") {
        return "Display URL regenerated";
    }
    if (details.type === "ServiceKeyIssued") {
        return details.newAccount === true ? "New service account" : "Configuration downloaded";
    }
    return "—";
}
